// extracted by mini-css-extract-plugin
module.exports = {"header":"NavHeader_header__fNIVL","toolBar":"NavHeader_toolBar__1CWMm","title":"NavHeader_title__2W3lz"};